<template>
  <section>
    <scroll-container
      class="pt-2 mt-n30px"
      :height-offset="isInEditMode ? '55px' : '125px'"
    >
      <b-container
        class="container-small"
      >
        <template v-if="loading">
          <b-card class="mb-2">
            <div class="text-center">
              <b-spinner label="Loading..." />
            </div>
          </b-card>
        </template>
        <b-card v-else class="mb-2">
          <div class="mb-2">
            <b-card-title
              v-if="model.displayAdEdit.adId === 0"
              class="mb-0"
            >
              {{ $tk('ClientPortal.Form.NewCatalogItem') }}
            </b-card-title>
            <b-card-title
              v-else
              class="mb-0"
            >
              {{ $tk('ClientPortal.Form.EditCatalogItem') }}
            </b-card-title>
            <b-breadcrumb class="m-0 p-0">
              <b-breadcrumb-item :to="`/${$route.params.accountId}/campaign/edit/${model.campaignModel.id}`">
                {{ model.campaignModel.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item :to="`/${$route.params.accountId}/adgroup/edit?adGroupId=${model.adGroup.id}&campaignId=${model.campaignModel.id}`">
                {{ model.adGroup.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-if="model.displayAdEdit.adId ===0"
                active
              >
                {{ $tk('ClientPortal.Form.NewAd') }}
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-else
                active
              >
                <!-- <GjIcon name="Desktop" /> -->
                {{ model.displayAdEdit.adName }}
              </b-breadcrumb-item>
            </b-breadcrumb>
            <hr class="m-0 mt-1">
          </div>
          <template v-if="isInEditMode">
            <b-form-group
              class="my-2"
              :label="$tk('ClientPortal.Form.AdName') + ' *'"
              :invalid-feedback="errors['Name']"
              :state="errors['Name'] == null ? null : false"
            >
              <b-form-input
                id="Name"
                v-model="model.displayAdEdit.adName"
                type="text"
                :state="errors['Name'] == null ? null : false"
                :placeholder="$tk('ClientPortal.Form.AdNamePlaceholder')"
              />
            </b-form-group>
            <b-card-title class="mb-25">
              {{ $tk('ClientPortal.Form.Info') }}
            </b-card-title>
            <b-card-text class="mb-2">
              {{ $tk('ClientPortal.Form.Info.Description') }}
            </b-card-text>
            <template v-if="model.displayAdEdit.catalogSetId && model.displayAdEdit.catalogSetId > 0">
              <b-form-group
                class="mb-2"
              >
                <legend class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.Info.Catalog') }}
                  <GjIcon name="Info" />
                </legend>
                <v-select
                  :value="model.catalogSet.catalogName"
                  :clearable="false"
                  label="name"
                  :disabled="true"
                />
              </b-form-group>

              <b-form-group
                class="mb-2"
              >
                <legend class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.Info.CatalogSet') }}
                  <GjIcon name="Info" />
                </legend>
                <v-select
                  :value="model.catalogSet.name"
                  :clearable="false"
                  label="name"
                  :disabled="true"
                />
              </b-form-group>
            </template>

            <template v-if="model.displayAdEdit.catalogItemModel">
              <b-form-group
                  class="mb-2"
              >
                <legend class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.Product') }} *
                  <GjIcon name="Info" />
                </legend>
                <div class="d-flex">
                  <b-avatar
                      :src="model.displayAdEdit.catalogItemModel.contentImageUrl"
                      variant="light"
                      size="3rem"
                  />
                  <label
                      class="mb-0 pt-1"
                  >
                    {{ model.displayAdEdit.catalogItemModel.contentName }}
                  </label>
                </div>
              </b-form-group>
            </template>
            <b-form-group
                id="Url"
                class="mb-2"
                :invalid-feedback="errors['Url']"
                :state="errors['Url'] == null ? null : false"
            >
              <legend class="col-form-label pt-0">
                {{ $tk('ClientPortal.Form.Url') }} *
                <GjIcon
                    v-b-tooltip.hover="$tk('ClientPortal.Form.URLTooltip')"
                    name="Info"
                />
              </legend>
              <b-form-input
                  v-model="model.displayAdEdit.url"
                  type="text"
                  :disabled="true"
                  placeholder="https://www.example.com/page"
                  :state="errors['Url'] == null ? null : false"
              />
            </b-form-group>
            <b-button
                v-b-toggle.url-builder
                class="bg-white mb-2"
                size="sm"
                variant="outline-primary"
            >
              <GjIcon
                  class="mr-50"
                  name="Hyperlink"
              />
              <span class="when-open">
                {{ $tk('ClientFormat.Form.CloseUrlBuilder') }}
                <GjIcon
                    class="mr-50"
                    name="ArrowUp"
                />
              </span>
              <span class="when-closed">
                {{ $tk('ClientFormat.Form.OpenUrlBuilder') }}
                <GjIcon
                    class="mr-50"
                    name="ArrowDown"
                />
              </span>
            </b-button>
            <b-collapse
                id="url-builder"
            >
              <url-builder
                :ref="'utm-'+model.displayAdEdit.id"
                :key="model.displayAdEdit.id"
                v-model="model.displayAdEdit.url"
                :options="model.utmOptions"
            />
            </b-collapse>
            <b-form-group
                class="mb-2"
            >
              <legend class="col-form-label pt-0">
                {{ $tk('ClientPortal.Form.ImpressionTag') }}
                <GjIcon
                    v-b-tooltip.hover="$tk('ClientPortal.Form.ImpressionTagTooltip')"
                    name="Info"
                />
              </legend>
              <b-form-textarea
                  v-model="model.displayAdEdit.impressionTag"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.ImpressionTagPlaceholder')"
                  rows="3"
              />
            </b-form-group>
          </template>
          <template
            v-else
          >
            <b-form-group
              class="mt-2 mb-0"
              label="Choose Catalog"
            >
              <v-select
                v-model="selectedCatalog"
                :clearable="false"
                label="name"
                class="smaller-indicator"
                :placeholder="$tk('ClientPortal.NativeAd.ChoseCatalog')"
                :options="model.catalogs"
                :get-option-key="catalog => catalog.encodedId"
                @option:selected="resetCatalogType()"
              />
            </b-form-group>
            <b-form-group
              v-if="selectedCatalog"
              class="mt-2 mb-0"
              :label="$tk('ClientPortal.Form.ChooseType')"
            >
              <b-form-row>
                <b-col sm="6">
                  <b-button
                    variant="outline-dark"
                    :class="{'text-primary btn-outline-primary' : model.displayAdEdit.catalogProductType == 1}"
                    class="d-flex justify-content-between align-items-center mb-50 mb-sm-0"
                    block
                    @click.prevent="openItemModal(selectedCatalog)"
                  >
                    {{ $tk('ClientPortal.Form.SelectItemsManually') }}
                    <b-form-radio
                      v-model="model.displayAdEdit.catalogProductType"
                      value="1"
                      class="radio-btn"
                    />
                  </b-button>
                </b-col>
                <b-col
                  v-if="configuration.clientConfiguration.showCatalogSet"
                  sm="6"
                >
                  <b-button
                    variant="outline-dark"
                    :class="{'text-primary btn-outline-primary' : model.displayAdEdit.catalogProductType == 2}"
                    class="d-flex justify-content-between align-items-center"
                    block
                    @click="setCatalogProductType(2)"
                  >
                    {{ $tk('ClientPortal.Form.UseFilters') }}
                    <b-form-radio
                      v-model="model.displayAdEdit.catalogProductType"
                      value="2"
                      class="radio-btn"
                    />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-form-group>
            <b-form-group
              v-if="model.displayAdEdit.catalogProductType == 2"
              id="CatalogSetId"
              class="mt-2 mb-0"
              :label="$tk('ClientPortal.Form.ChooseCatalogSet')"
              :invalid-feedback="catalogSet.errors['CatalogSetId']"
              :state="catalogSet.errors['CatalogSetId'] == null ? null : false"
            >
              <b-form-row>
                <b-col :sm="canAccountCreateSet(selectedCatalog.accountId) ? 11 : 12">
                  <b-form-group
                    :state="catalogSet.errors['CatalogSetId'] == null ? null : false"
                  >
                    <v-select
                      v-model="model.displayAdEdit.catalogSetId"
                      :clearable="false"
                      label="name"
                      class="custom-b-selkect"
                      :options="catalogSets"
                      :placeholder="$tk('ClientPortal.Form.ChooseCatalogSet')"
                      :reduce="set => set.id"
                      @input="selectedCatalogSet()"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="canAccountCreateSet(selectedCatalog.accountId)"
                  class="pt-50 text-center"
                  sm="1"
                >
                  <b-link
                    variant="link"
                    :to="redirectToCatalogSetCreate(selectedCatalog)"
                  >
                    <GjIcon
                      name="Plus"
                    />
                  </b-link>
                </b-col>
              </b-form-row>
              <b-skeleton
                v-if="loadingCatalogSetItemsCount"
                animation="wave"
                width="45%"
                height="15px"
                class="my-25"
              />
              <template
                v-if="!loadingCatalogSetItemsCount && model.displayAdEdit.catalogSetId > 0"
                #description
              >
                This catalog set contains {{ catalogSet.itemsCount }} items.
              </template>
            </b-form-group>
            <template v-if="model.displayAdEdit.catalogSetId > 0">
              <b-form-group
                id="Name"
                class="mt-2 mb-0"
                :label="$tk('ClientPortal.Form.AdName') + ' *'"
                :invalid-feedback="catalogSet.errors['Name']"
                :state="catalogSet.errors['Name'] == null ? null : false"
              >
                <b-form-input
                  v-model="catalogSet.name"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.NamePlaceHolder')"
                  :state="catalogSet.errors['Name'] == null ? null : false"
                />
              </b-form-group>
            </template>
          </template>
        </b-card>
        <!--ADS-->
        <!--TODO: Change design-->
        <template v-if="!loading">
          <b-card
            v-for="(catalogProduct,catalogProductIndex) in model.catalogProducts"
            :key="catalogProductIndex"
            class="mb-2"
          >
          <div class="position-relative bg-light border rounded-sm mb-2">
            <div
              class="products-img"
              :style="{ backgroundImage: 'url(' + catalogProduct.imageUrl + ')' }"
            />
            <div class="position-absolute bg-white rounded-sm top-50 right-50 p-25">
              <b-button
                class="px-0"
                size="sm"
                variant="link"
                @click="removeCatalogProductAd(catalogProductIndex)"
              >
                <GjIcon
                  class="text-secondary"
                  name="Delete"
                />
              </b-button>
            </div>
          </div>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdName')"
            :invalid-feedback="catalogProduct.errors['Name']"
          >
            <b-form-input
              id="Name"
              v-model="catalogProduct.name"
              type="text"
              name="name"
              :state="catalogProduct.errors['Name'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.Format')"
          >
            <v-select
              v-model="catalogProduct.formatId"
              :options="model.adFormats"
              label="name"
              :reduce="format => format.id"
            />
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.Url')"
            :invalid-feedback="catalogProduct.errors['Url']"
          >
            <b-form-input
              id="Url"
              v-model="catalogProduct.url"
              type="text"
              name="url"
              :state="catalogProduct.errors['Url'] == null ? null : false"
              disabled
            />
          </b-form-group>
          <b-button
            v-b-toggle="'url-builder-'+catalogProductIndex"
            class="bg-white mb-2"
            size="sm"
            variant="outline-primary"
          >
            <GjIcon
              class="mr-50"
              name="Hyperlink"
            />
            <span class="when-open">
              {{ $tk('ClientFormat.Form.CloseUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowUp"
              />
            </span>
            <span class="when-closed">
              {{ $tk('ClientFormat.Form.OpenUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowDown"
              />
            </span>
          </b-button>
          <b-collapse
            :id="'url-builder-'+catalogProductIndex"
          >
            <url-builder
              :ref="'utm'+catalogProductIndex"
              :key="catalogProductIndex"
              v-model="catalogProduct.url"
              :options="model.utmOptions"
              :is-product-ad="true"
            />
          </b-collapse>
          <b-form-group
            class="mb-0"
            :label="$tk('ClientPortal.Form.ImpressionTag')"
          >
            <b-form-input
              v-model="catalogProduct.impressionTag"
              type="text"
              name="impression-tag"
            />
          </b-form-group>
        </b-card>
        </template>
      </b-container>
    </scroll-container>

    <div class="border-top text-right py-1">
      <div class="container-small mx-auto">
        <b-button
          v-if="isInEditMode"
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          @click="closeEditModal"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          v-else
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          @click="cancelAd"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="bg-white ml-50"
          variant="primary"
          size="sm"
          :disabled="isSaveButtonDisabled()"
          @click="saveCatalogItem()"
        >
          {{ isInEditMode ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.CreateAd') }}
        </b-button>
      </div>
    </div>
    <b-modal
      id="catalog-item-modal"
      ref="catalog-item-modal"
      body-class="modal-body--no-padding"
      hide-footer
      :title="$tk('ClientPortal.CatalogItem.CatalogItems')"
      size="xl"
      centered
    >
      <div class="mx-1 mb-1">
        <b-form-row>
          <b-col
            sm="6"
            class="mb-50 mb-sm-0"
          >
            <b-form-input
              v-model="catalogModel.filter.name"
              type="text"
              :placeholder="$tk('ClientPortal.CatalogItem.Search')"
              @input="filterItemsByName"
            />
          </b-col>
          <b-col
            sm="3"
            class="mb-50 mb-sm-0"
          >
            <multiselect
              v-model="catalogModel.filter.brands"
              :placeholder="$tk('ClientPortal.Form.SearchBrands')"
              :option-height="104"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="true"
              :show-labels="false"
              :options="brands"
              :internal-search="false"
              :loading="loadingMultiselect"
              @input="filterItems"
              @focus.stop=""
              @search-change="(name) => loadBrands(name)"
            >
              <template
                slot="caret"
                slot-scope="{ toggle }"
              >
                <div
                  class="multiselect__select"
                  @mousedown.prevent.stop="toggle()"
                >
                  <GjIcon
                    class="icon-wrapper"
                    name="ArrowDown_fill"
                    size="21"
                  />
                </div>
              </template>
            </multiselect>
          </b-col>
          <b-col
            sm="3"
          >
            <multiselect
              v-model="catalogModel.filter.categories"
              :options="categories"
              :placeholder="$tk('ClientPortal.Form.SearchCategories')"
              :option-height="104"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              :show-labels="false"
              input="filterItems"
              :internal-search="false"
              :loading="loadingMultiselect"
              @focus.stop=""
              @search-change="(name) => loadCategories(name)"
            >
              <template
                slot="caret"
                slot-scope="{ toggle }"
              >
                <div
                  class="multiselect__select"
                  @mousedown.prevent.stop="toggle()"
                >
                  <GjIcon
                    class="icon-wrapper"
                    name="ArrowDown_fill"
                    size="21"
                  />
                </div>
              </template>
            </multiselect>
          </b-col>
        </b-form-row>
      </div>
      <hr class="mb-0">

      <scroll-container
        class="pt-1 px-1"
        height-offset="260px"
      >
        <b-row class="mx-n50">
          <b-col
            v-for="item in catalogModel.items"
            :key="item.id"
            xl="2"
            md="3"
            sm="6"
            cols="12"
            class="mb-1 px-50"
          >
            <b-card
              class="mb-0 h-100 border hover-pointer"
              body-class="d-flex flex-direction-column"
              :class="{'border-primary' : item.selected}"
              @click.prevent="selectCatalogProduct(item)"
            >
              <div class="text-right">
                <b-form-checkbox
                  v-model="item.selected"
                  class="d-inline-block pl-1"
                />
              </div>
              <b-card
                class="mb-2"
                body-class="p-0"
              >
                <div
                  class="products-img text-center mx-auto"
                  :style="{ backgroundImage: 'url(' + item.imageUrl + ')' }"
                />
              </b-card>

              <b-card-title class="mb-1">
                {{ item.title }}
              </b-card-title>
              <div class="mt-auto">
                <p class="mb-50">
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.CatalogItem.Id') }}:
                  </span>
                  {{ item.contentId }}
                </p>
                <p
                  class="mb-50"
                >
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.Catalogs.Price') }}:
                  </span>
                  {{ item.price }}
                </p>
                <p
                  class="mb-50"
                >
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.Catalogs.PriceWithDiscount') }}:
                  </span>
                  {{ item.priceWithDiscount }}
                </p>
                <p
                  class="mb-50"
                >
                  <span class="font-weight-bold">
                    {{ $tk('ClientPortal.CatalogItem.Stock') }}:
                  </span>
                  {{ item.stock }}
                </p>
                <a
                  :href="item.productUrl"
                  target="_blank"
                  class="text-uppercase text-danger font-weight-bold mt-1 mb-0"
                >
                  {{ $tk('ClientPortal.Catalogs.Link') }}
                </a>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <div class="text-center">
          <div v-if="catalogModel.items.length === 0 && !catalogModel.loading">
            {{ $tk('ClientPortal.CatalogItem.NoItems') }}
          </div>
          <div v-if="catalogModel.loading">
            <b-spinner
              label="Loading..."
            />
          </div>
          <!-- <loader
            :size="10"
            :show="catalogModel.loading"
            class="d-inline-block ml-2"
          /> -->
          <div
            v-if="!loadedAllItems && !catalogModel.loading"
            class="text-center mb-1"
          >
            <b-button
              variant="primary"
              class="text-center"
              size="sm"
              @click="loadItems()"
            >
              {{ $tk('ClientPortal.CatalogItem.LoadMore') }}
            </b-button>
          </div>
        </div>
      </scroll-container>
      <div class="p-1 border-top text-right">
        <b-button
          class=""
          variant="outline-secondary"
          size="sm"
          @click.prevent="hideGallery"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="ml-50"
          variant="primary"
          size="sm"
          @click.prevent="addCatalogProducts()"
        >
          {{ $tk('ClientPortal.Form.Add') }}
        </b-button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Multiselect from 'vue-multiselect'
import notification from '@/mixins/toastification'
import sweetAlert from '@/mixins/sweetAlert'
import ScrollContainer from '@/components/ScrollContainer.vue'
import UrlBuilder from '@/components/UrlBuilder.vue'
import { mapGetters } from 'vuex'
import CatalogSetsService from '@/api/client/catalogSets.service'
import AdsService from '@/api/client/ads.service'
import CatalogsService from '@/api/client/catalogs.service'
import 'vue-swatches/dist/vue-swatches.css'
import scrollToError from '@/mixins/scrollToError'
import vSelect from 'vue-select'

function debounce(fn, delay) {
  let timeoutID = null
  // eslint-disable-next-line func-names
  return function () {
    clearTimeout(timeoutID)
    // eslint-disable-next-line prefer-rest-params
    const args = arguments
    const that = this
    timeoutID = setTimeout(() => {
      fn.apply(that, args)
    }, delay)
  }
}

const CATALOG_PRODUCT_TYPES = {
  MANUAL: 1,
  SET: 2,
}
export default {
  inject: ['closeEditModal'],
  components: {
    GjIcon,
    Multiselect,
    ScrollContainer,
    UrlBuilder,
    vSelect,
  },
  mixins: [notification, sweetAlert],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    adId: Number,
    // eslint-disable-next-line vue/require-default-prop
    adGroupId: Number,
    // eslint-disable-next-line vue/require-default-prop
    catalogSetId: {
      type: String,
    },
    saving: {
      type: Boolean,
    },
  },
  data() {
    return {
      model: {
        displayAdEdit: {},
        campaignModel: {},
        adGroup: {},
        catalogSet: {},
        catalogProducts: [],
      },
      type: 0,
      errors: {},
      preview: false,
      customizeColors: false,
      color: '',
      name: '',
      dropzoneOptions: {
        uploadMultiple: false,
        maxFiles: 1,
        acceptedFiles: '.jpg,.png,.jpeg,.gif',
        url: 'url',
        thumbnailWidth: null,
        thumbnailHeight: null,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
      catalogModel: {
        encodedId: '0',
        items: [],
        loading: false,
        filter: {
          name: '',
          brands: [],
          categories: [],
        },
      },
      endpointType: {
        CATALOG_PRODUCT: 2,
      },
      uploadMessage: '',
      brands: [],
      categories: [],
      loadingMultiselect: false,
      loadedAllItems: false,
      searchingCatalogItems: false,
      productInfo: {
        imageUrl: '',
      },
      selectedCatalog: null,
      loadingCatalogSetItemsCount: false,
      catalogSet: {
        errors: {},
      },
      catalogSets: null,
      loading: false,
      index: null,
    }
  },
  computed: {
    isFormComplete() {
      const { displayAdEdit } = this.model
      return displayAdEdit.name && displayAdEdit.url
    },
    isInEditMode() {
      return this.adId > 0
    },
    ...mapGetters(['configuration']),
  },
  async mounted() {
    this.loading = true
    try {
      this.model = await AdsService.getAd(this.adId, this.adGroupId, this.catalogSetId, this.$route.params.accountId)
    } catch (error) {
      this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
    } finally {
      this.loading = false
    }
    if (!this.isInEditMode) {
      this.type = this.endpointType.CATALOG_PRODUCT
    }
    this.autoCompletedisplayAdEdit()
  },
  methods: {
    setSaving(value) {
      this.$emit('onUpdate', value)
    },
    async saveCatalogItem() {
      const { displayAdEdit } = this.model
      let { catalogProductType } = displayAdEdit
      const isInEditMode = displayAdEdit.adId > 0

      if (isInEditMode) {
        catalogProductType = this.catalogSetId && this.catalogSetId !== '0' ? CATALOG_PRODUCT_TYPES.SET : CATALOG_PRODUCT_TYPES.MANUAL
      }

      const catalogProductsModel = {
        catalogProducts: this.model.catalogProducts,
        catalogSet: this.catalogSet,
        productType: catalogProductType,
      }

      if (catalogProductsModel.productType === 0 && !isInEditMode) {
        this.setSaving(false)
        return
      }

      if (CATALOG_PRODUCT_TYPES.SET === catalogProductsModel.productType) {
        try {
          if (isInEditMode) {
            const { entity } = this.$parent.$parent.$parent
            const response = await AdsService.editDisplayAd(displayAdEdit, this.$route.params.accountId)
            if (response.updated || response.success) {
              entity.name = displayAdEdit.adName
              this.success(response.message)
              this.closeEditModal()
            } else {
              if (response.catalogSet?.errors) {
                this.catalogSet.errors = response.catalogSet.errors
              } else if (response.errors) {
                this.errors = response.errors
              }
              this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
            }
            this.setSaving(false)
          } else {
            const response = await AdsService.createCatalogSetDisplayAd(catalogProductsModel.catalogSet, this.$route.params.accountId)
            this.catalogSet = response.catalogSet
            if (response.success) {
              this.sweetAlertAfterAdCreation()
              this.setSaving(true)
            } else {
              this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
              this.setSaving(false)
            }
          }
        } catch (error) {
          this.error(error.message || 'Error saving ad')
          this.setSaving(false)
        }
      } else {
        try {
          if (isInEditMode) {
            const response = await AdsService.editDisplayAd(displayAdEdit, this.$route.params.accountId)
            if (response.updated) {
              const { entity } = this.$parent.$parent.$parent
              entity.name = displayAdEdit.adName
              this.success(response.message)
              this.closeEditModal()
            } else {
              this.errors = response.errors || {}
              this.error(response.message || this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
            }
            this.setSaving(false)
          } else {
            const response = await AdsService.createDisplayCatalogItemAds(catalogProductsModel.catalogProducts, this.$route.params.accountId)
            this.model.catalogProducts = response.catalogProducts
            this.errors = response.errors
            if (response.success) {
              this.sweetAlertAfterAdCreation()
              this.setSaving(true)
            } else {
              this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
              this.$nextTick(() => {
                scrollToError(this.errors)
              })
              this.setSaving(false)
            }
          }
        } catch (error) {
          this.error(error.message)
          this.setSaving(false)
        }
      }
    },
    cancelAd() {
      this.$router.push(`/${this.$route.params.accountId}`)
      // this.$router.push(`/${this.$route.params.accountId}/ad/create`)
    },
    checkFileThumbnail(index) {
      this.dropzoneIndex = index
      this.setSaving(true)
    },
    openItemModal(catalog) {
      this.catalogModel = {
        encodedId: catalog.encodedId,
        catalogType: catalog.catalogType,
        items: [],
        page: 0,
        loading: true,
        filter: {
          name: '',
          brands: [],
          categories: [],
        },
      }
      this.loadedAllItems = false
      this.model.displayAdEdit.catalogSetId = null
      this.$set(this.model.displayAdEdit, 'catalogProductType', 1)
      this.$refs['catalog-item-modal'].show()
      this.loadItems()
    },
    async loadItems() {
      if (this.searchingCatalogItems || this.loadedAllItems) return

      this.catalogModel.loading = true
      this.searchingCatalogItems = true
      const filter = {
        catalogId: this.catalogModel.encodedId,
        page: this.catalogModel.page,
        name: this.catalogModel.filter.name,
        brands: this.catalogModel.filter.brands,
        categories: this.catalogModel.filter.categories,
      }
      try {
        const response = await CatalogsService.getCatalogItemDetails(this.catalogModel.encodedId, filter, this.$route.params.accountId)
        const existingItems = this.catalogModel.items
        const itemsFromSearch = response.filter(x => existingItems.findIndex(y => y.catalogItemId === x.catalogItemId) < 0)
        this.catalogModel.items.push(...itemsFromSearch)
        if (response.length === 0) this.loadedAllItems = true
      } catch (error) {
        this.error(error)
      } finally {
        this.catalogModel.loading = false
        this.catalogModel.page += 1
        this.searchingCatalogItems = false
      }
    },
    filterItemsByName: debounce(function () {
      if (this.catalogModel.filter.name.length === 1) { return }
      this.filterItems()
    }, 500),
    filterItems() {
      this.catalogModel.page = 0
      this.loadedAllItems = false
      this.catalogModel.items = this.catalogModel.items.filter(x => x.selected)
      this.loadItems()
    },
    selectCatalogProduct(catalogProduct) {
      this.$set(catalogProduct, 'selected', !catalogProduct.selected)
    },
    addCatalogProducts() {
      if (!Object.prototype.hasOwnProperty.call(this.model, 'catalogProducts')) {
        this.$set(this.model, 'catalogProducts', [])
      }
      const selectedCatalogProducts = this.catalogModel.items.filter(x => x.selected)
      this.$refs['catalog-item-modal'].hide()
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selectedCatalogProducts.length; i++) {
        const catalogProduct = selectedCatalogProducts[i]
        const existsCatalogProduct = this.model.catalogProducts.filter(x => x.catalogItemId === catalogProduct.catalogItemId)
        // eslint-disable-next-line no-continue
        if (existsCatalogProduct.length !== 0) { continue }

        const displayAdEdit = {
          adGroupId: this.model.adGroup.id,
          adId: 0,
          formatId: 1,
          catalogItemId: catalogProduct.catalogItemId,
          imageUrl: catalogProduct.imageUrl,
          errors: {},
          url: '{{product_url}}',
          impressionTag: '',
          name: `${catalogProduct.contentId} - ${catalogProduct.title}`,
        }
        this.model.catalogProducts.push(displayAdEdit)
      }
    },
    hideGallery() {
      this.$refs['catalog-item-modal'].hide()
    },
    removeCatalogProductAd(index) {
      this.model.catalogProducts.splice(index, 1)
    },
    async loadBrands(name) {
      if (this.loadingMultiselect || name.length < 2) return

      this.loadingMultiselect = true
      try {
        const response = await CatalogsService.searchCatalogBrands(this.catalogModel.encodedId, name, this.$route.params.accountId)
        this.brands = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingMultiselect = false
      }
    },
    async loadCategories(name) {
      if (this.loadingMultiselect || name.length < 2) return

      this.loadingMultiselect = true
      try {
        const response = await CatalogsService.searchCatalogCategories(this.catalogModel.encodedId, name, this.$route.params.accountId)
        this.categories = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingMultiselect = false
      }
    },
    setCatalogProductType(type) {
      this.$set(this.model, 'catalogProducts', [])
      this.$set(this.model.displayAdEdit, 'catalogProductType', type)
    },
    async loadCatalogSets(catalogSetIdSelected = 0) {
      try {
        const response = await CatalogSetsService.getCatalogSets(this.selectedCatalog.encodedId, this.$route.params.accountId)
        this.catalogSets = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingMultiselect = false
        if (catalogSetIdSelected !== 0) this.selectedCatalogSet()
      }
    },
    resetCatalogType() {
      this.$set(this.model.displayAdEdit, 'catalogProductType', 0)
      // to hide adname field
      this.$set(this.model.displayAdEdit, 'catalogSetId', null)
      this.loadCatalogSets()
    },
    redirectToCatalogSetCreate(selectedCatalog) {
      const { accountId } = this.$route.params
      const { adGroupId } = this.$route.query
      return `/${accountId}/catalogs/${selectedCatalog.encodedId}/sets/create?adGroupId=${adGroupId}`
    },
    selectedCatalogSet() {
      this.model.catalogProducts = []
      const catalogSetIdToUse = this.catalogSetId
        ? parseInt(this.catalogSetId, 10)
        : this.model.displayAdEdit.catalogSetId
      const catalogSet = this.catalogSets.find(x => x.id === catalogSetIdToUse)
      if (catalogSet) {
        const isEditMode = this.model.displayAdEdit && this.model.displayAdEdit.adId > 0
        const catalogSetModel = {
          adGroupId: this.model.adGroup.id,
          adId: this.model.displayAdEdit.adId || 0,
          formatId: this.model.displayAdEdit.formatId || 1,
          catalogSetId: catalogSetIdToUse,
          name: isEditMode ? this.model.displayAdEdit.adName : `${catalogSet.name} - ${catalogSet.encodedId}`,
          errors: {},
          imageUrl: '{{image_url}}',
          url: isEditMode ? this.model.displayAdEdit.url : '{{product_url}}',
          impressionTag: this.model.displayAdEdit.impressionTag || '',
          itemsCount: 0,
        }
        this.catalogSet = catalogSetModel
      }
      this.loadCatalogSetItemsCount()
    },
    canAccountCreateSet(selectedCatalogAccountId) {
      return selectedCatalogAccountId === this.$route.params.accountId
    },
    async loadCatalogSetItemsCount() {
      this.loadingCatalogSetItemsCount = true
      try {
        const catalogSetIdToUse = this.catalogSetId
          ? parseInt(this.catalogSetId, 10)
          : this.model.displayAdEdit.catalogSetId
        const response = await CatalogSetsService.getCatalogSetItemsCount(this.selectedCatalog.encodedId, catalogSetIdToUse, this.$route.params.accountId)
        this.catalogSet.itemsCount = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingCatalogSetItemsCount = false
      }
    },
    isSaveButtonDisabled() {
      if (this.saving) return true

      if (this.loadingCatalogSetItemsCount) return true

      if (this.type === this.endpointType.CATALOG_PRODUCT) {
        if (!this.selectedCatalog) return true

        if (this.model.displayAdEdit.catalogProductType === 0) return true

        if (this.model.displayAdEdit.catalogProductType === CATALOG_PRODUCT_TYPES.MANUAL && (!this.model.catalogProducts || this.model.catalogProducts.length === 0)) return true

        if (this.model.displayAdEdit.catalogProductType === CATALOG_PRODUCT_TYPES.SET && this.model.displayAdEdit.catalogSetId <= 0) return true
      }
      return false
    },
    autoCompletedisplayAdEdit() {
      if (this.model.selectedCatalog == null) return

      this.$set(this, 'selectedCatalog', this.model.selectedCatalog)
      this.$set(this, 'type', 2)
      this.setCatalogProductType(2)
      const catalogSetIdToLoad = this.catalogSetId
        ? parseInt(this.catalogSetId, 10)
        : this.model.displayAdEdit.catalogSetId

      this.loadCatalogSets(catalogSetIdToLoad)
    },
  },
}

</script>

<style lang="scss">
@import '@/assets/scss/views/client/ads-manager/create/ads/display-ad.scss';
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
